/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamAdvanceTrigger } from './oralExamAdvanceTrigger';
import type { OralExamAdvanceRequestQuestionId } from './oralExamAdvanceRequestQuestionId';

/**
 * Optional body for question advance (defaults to lecturer_next).
 */
export interface OralExamAdvanceRequest {
  trigger?: OralExamAdvanceTrigger;
  questionId?: OralExamAdvanceRequestQuestionId;
}
